type PaymentUiLogContext = Record<string, unknown>;

function write(
  level: "info" | "warn" | "error",
  event: string,
  context?: PaymentUiLogContext,
) {
  const payload = context ? JSON.stringify(context) : "";
  const line = payload ? `${event} ${payload}` : event;

  switch (level) {
    case "info":
      console.info("[pos-payment-ui]", line);
      break;
    case "warn":
      console.warn("[pos-payment-ui]", line);
      break;
    case "error":
      console.error("[pos-payment-ui]", line);
      break;
  }
}

export const paymentUiLog = {
  info: (event: string, context?: PaymentUiLogContext) =>
    write("info", event, context),
  warn: (event: string, context?: PaymentUiLogContext) =>
    write("warn", event, context),
  error: (event: string, context?: PaymentUiLogContext) =>
    write("error", event, context),
};
